// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/tkLib.js#1 $
'use strict';

/** 
* @ngdoc service 
* @name tcApp.TkLibService
* @description
* TkLib Service adds tkLib functions to $scope, allowing to run old JS files without rewrite
*
*/
angular.module('tc.tkLib', ['tc.legacyScope'])
.service('TkLibService', function($timeout, $parse, $window, $injector, $log,
									LegacyScopeSearchService) { 
	var $this = this;

	// Store the namespace members for use in Injection
	$this.namespaceId = '';
	$this.namespaceMembers = [];
	
	function _tkLib() {
		var _this = this;
		_this.selectors = [];
		_this.selectorTags = [];
		_this.scope = [];

		// ().val(newValue)
		//
		// When used with no parameter returns the .value of the first selected element
		// When used with a parameter sets all selected elements to the same passed in value
		_this.val = function(newValue) {
			var isAssignment = angular.isDefined(newValue);
			var result;
			angular.forEach(_this.selectors, function(thisSelector) {
				if (isAssignment) {
					_this.scope['websys_setValue'](thisSelector.id, newValue);
				} else {
					if (angular.isUndefined(result)) result = thisSelector.value;
				}
			});
			// If it's not an assignment then we will only get here if the element does not exist - 
			// in this case return a blank value
			// Otherwise return the tkLib object
			if (angular.isDefined(result)) return result;
			return (!isAssignment) ? '' : _this;
		};

		// ().html(newValue)
		//
		// When used with no parameter returns the .value of the first selected element
		// When used with a parameter sets all selected elements to the same passed in value
		// Alias for val() -- however in TrakCare UI, different item types need either one of val or html.
		_this.html = _this.val;

		// ().on(eventName, eventHandler)
		//
		// When used with no eventHandler passed in returns the current event handler for the 'eventName'
		// When used with an eventHandler passed in, sets the event handler for all selected elements for 
		// the 'eventName' event to the 'eventHandler'
		// When used with a blank eventHandler passed in, removes any existing event handler for the selected 
		// elements for the 'eventName' event
		//
		// NB: This assigns the 'on' 'eventName' attribute to the event handler - i.e. does not add via addEventListener
		// Only click, change and blur (same as change) events are supported.
		_this.on = function(eventName, eventHandler) {
			var isAssignment = angular.isDefined(eventHandler);
			var eventNames = eventName.split(' ');
			var evIdx, thisEventName, i, thisSelector;

			for (evIdx in eventNames) {
				if (!Object.prototype.hasOwnProperty.call(eventNames, evIdx)) continue;
				thisEventName = eventNames[evIdx];

				for (i in _this.selectors) {
					if (!Object.prototype.hasOwnProperty.call(_this.selectors, i)) continue;
					thisSelector = _this.selectors[i];

					if ((!isAssignment) && ((thisEventName === 'change' || thisEventName === 'blur'))) {
						return thisSelector.onChangeHandler;
					}

					if ((!isAssignment) && ((thisEventName === 'click'))) {
						return thisSelector.onclick;
					}

					if (eventHandler === '') eventHandler = undefined;
					if ((thisEventName === 'change' || thisEventName === 'blur')) {
						thisSelector.onChangeHandler = eventHandler;
					} else if ((thisEventName === 'click')) {
						thisSelector.onclick = eventHandler;
					} else {
						// Allow other events to use listeners, e.g. 'lookupselect'
						if (angular.isDefined(eventHandler)) {
							_this.scope['websys_addListener'](thisEventName, '', eventHandler, thisSelector);
						} else {
							_this.scope['websys_removeListener'](thisEventName, '', null, thisSelector);
						}
					}
				}
			}
			return _this;
		};

		// ().fireEvent(eventName, doc)
		//
		// Raises a given set of event in the order given against the current selectors in turn.
		// Event names are separated by spaces
		// All specified events will be fired against each selector then the next selector will have all the events fired etc.
		// Event names are change,click,blur
		_this.fireEvent = function(eventName) {
			// we need websys_fireEvent
			if (!_this.scope['websys_fireEvent']) return _this;
			var eventNames = eventName.split(' ');
			var evIdx, thisEventName, i, thisSelector;
			for (evIdx in eventNames) {
				if (!Object.prototype.hasOwnProperty.call(eventNames, evIdx)) continue;

				thisEventName = eventNames[evIdx];

				for (i in _this.selectors) {
					if (!Object.prototype.hasOwnProperty.call(_this.selectors, i)) continue;
					thisSelector = _this.selectors[i];
					_this.scope['websys_fireEvent'](thisSelector, thisEventName);
				}
			}
			return _this;
		};

		// ().prop(propName, propValue)
		// ().attr(propName, propValue)
		//
		// Operates on properties that are on or off - either returns the current state of the first selector or applies 
		// the Yes/No state to all selected elements that apply
		// propValue, if passed, must be true or false
		//
		// propName is a set of proprties that can be the context of the operation:
		//  disabled            Sets/unsets the 'disabled' attribute of element(s). Modifies className for <a> elements
		//  visible             Sets/unsets the 'style.visibility' attribute of element(s)
		//  readonly            Sets/unsets the 'readOnly' attribute of element(s)
		//  checked             Sets/unsets the 'checked' attribute of element(s) of type <input type='checkbox'>
		//  required            Sets/unsets the 'required' attribute of element(s) and any label for the element. 
		//  bold				Sets/unsets the bold state for links (tagged custom elements or link component items)
		//						Modifies the className of the element
		//  defaultValue        Gets the defaultValue property of the 1st selector
		//  defaultChecked      Gets the defaultChecked property of the 1st selector
		// When invoked without a propValue parameter returns the first selected element value of the property
		// When invoked with a propValue parameter, sets all selected elements to the propValue (where appropriate)
		//
		// Throws
		//  Error   When propValue is not of type 'boolean', i.e. true or false
		_this.prop = function(propName, propValue) {
			var isAssignment = angular.isDefined(propValue);
			if (isAssignment && (typeof propValue !== 'boolean')) {
				throw new Error('tkLib.prop(' + propName + ',' + propValue + ')'
					+ ' - 2nd parameter, if present, expected to be of type boolean');
			}
			var parseExpression = function(expression) {
				if (angular.isString(expression)) return $parse(expression)(_this.scope);
				return expression;
			};
			var selectorIndex,thisSelector;
			for (selectorIndex in _this.selectors) {
				if (!Object.prototype.hasOwnProperty.call(_this.selectors, selectorIndex)) continue;
				thisSelector = _this.selectors[selectorIndex];
				if (propName === 'disabled') {
					if (angular.isDefined(thisSelector.displayType)) {
						if (!isAssignment) return parseExpression(thisSelector.disabled);
						// Call the same functions as websys library
						if ((propValue) && (angular.isFunction(_this.scope['DisableField']))) {
							_this.scope['DisableField']('', true, thisSelector);
						} else if ((!propValue) && (angular.isFunction(_this.scope['EnableField']))) {
							_this.scope['EnableField']('', thisSelector, false);
						} else {
							// Fallback - theoretically should never be called
							thisSelector.disabled = propValue;
						}
					} else if (angular.isDefined(_this.selectorTags[selectorIndex])) {
						// Handle tagged custom elements
						if (!isAssignment) {
							return _this.scope['websys_isClass']({
								tag: _this.selectorTags[selectorIndex],
								className: 'disabledField'
							});
						}
						if (propValue) {
							_this.scope['websys_setClass']({
								tag: _this.selectorTags[selectorIndex],
								className: 'disabledField'
							});
						} else {
							_this.scope['websys_setClass']({
								tag: _this.selectorTags[selectorIndex],
								classNamesToRemove: {1: 'disabledField'}
							});
						}
					}
				} else if (propName === 'visible') {
					if (!isAssignment) return !parseExpression(thisSelector.hidden);
					if ((propValue) && (angular.isFunction(_this.scope['websysEdit_ShowField']))) {
						_this.scope['websysEdit_ShowField']('', thisSelector);
					} else if ((!propValue) && (angular.isFunction(_this.scope['websysEdit_HideField']))) {
						_this.scope['websysEdit_HideField']('', thisSelector, false);
					} else {
						thisSelector.hidden = propValue;
					}
				} else if (propName === 'readonly') {
					if (!isAssignment) return parseExpression(thisSelector.readOnly);
					if ((propValue) && (angular.isFunction(_this.scope['ReadOnlyField']))) {
						_this.scope['ReadOnlyField']('', thisSelector);
					} else if ((!propValue) && (angular.isFunction(_this.scope['UndoReadOnlyField']))) {
						_this.scope['UndoReadOnlyField']('', thisSelector);
					} else {
						thisSelector.readOnly = propValue;
					}
				} else if (propName === 'checked') {
					// Filter out non-checkbox elements
					if (thisSelector.displayType !== 'C') continue;
					if (!isAssignment) return thisSelector.value;
					thisSelector.value = propValue;
				} else if (propName === 'required') {
					if (!isAssignment) return parseExpression(thisSelector.required);
					if ((propValue) && (angular.isFunction(_this.scope['MandatoryField']))) {
						_this.scope['MandatoryField'](thisSelector);
					} else if ((!propValue) && (angular.isFunction(_this.scope['UndoMandatoryField']))) {
						_this.scope['UndoMandatoryField'](thisSelector);
					} else {
						thisSelector.required = propValue;
					}
				} else if (propName === 'bold') {
					if (angular.isDefined(thisSelector.displayType)) {
						if (thisSelector.displayType !== 'A') continue;
						if (!isAssignment) return _this.scope['websys_isClass']({item: thisSelector, className: 'clsBoldLink'});
						if (propValue) {
							_this.scope['websys_setClass']({
								item: thisSelector,
								className: 'clsBoldLink'}
							);
						} else {
							_this.scope['websys_setClass']({
								item: thisSelector,
								classNamesToRemove: {1: 'clsBoldLink'}
							});
						}
					} else if (angular.isDefined(_this.selectorTags[selectorIndex])) {
						// Handle tagged custom elements
						if (!isAssignment) {
							return _this.scope['websys_isClass']({
								tag: _this.selectorTags[selectorIndex],
								className: 'clsBoldLink'
							});
						}
						if (propValue) {
							_this.scope['websys_setClass']({
								tag: _this.selectorTags[selectorIndex],
								className: 'clsBoldLink'
							});
						} else {
							_this.scope['websys_setClass']({
								tag: _this.selectorTags[selectorIndex],
								classNamesToRemove: {1: 'clsBoldLink'}
							});
						}
					}
				} else if (propName === 'defaultValue') {
					// Read only
					if (!isAssignment) return thisSelector.defaultValue;
				} else if (propName === 'defaultChecked') {
					// Read only
					if (!isAssignment) return thisSelector.defaultValue;
				}
			}
			//
			// If we get here and have not returned a value yet then default to return false
			// This can occur if there are no selectors or the selectors do not match sub-prop filters, e.g.
			//      var isChecked = tkLib('#NotACheckBox').prop('checked');
			// Should return false even if the form element 'NotACheckBox' is not present or is not a checkbox
			if (!isAssignment) return false;
			//
			// Otherwise just return this object
			return _this;
		};
		_this.attr = _this.prop;

		// ().show()
		// Shorthand for ().prop('visible',true)
		_this.show = function() {
			return _this.prop('visible', true);
		};

		// ().hide()
		// Shorthand for ().prop('visible',false)
		_this.hide = function() {
			return _this.prop('visible', false);
		};

		// ().disable()
		// Shorthand for ().prop('disabled',true)
		_this.disable = function() {
			return _this.prop('disabled', true);
		};

		// ().enable()
		// Shorthand for ().prop('disabled',false)
		_this.enable = function() {
			return _this.prop('disabled', false);
		};

		// ().remove()
		//
		// Disables and hides all selected elements. Does NOT perform DOM manipulation
		// Equivalent to .hide().disable()
		_this.remove = function() {
			_this.prop('visible', false).prop('disabled', true);
		};
		
		// ().hideLookup() or ().removeLookup()
		//
		// Hides/removes the lookup on input fields
		_this.removeLookup = _this.hideLookup = function() {
			var i, thisSelector;
			for (i in _this.selectors) {
				if (!Object.prototype.hasOwnProperty.call(_this.selectors, i)) continue;
				thisSelector = _this.selectors[i];
				_this.scope['websysEdit_RemoveLookup'](thisSelector.id);
			}
			return _this;
		};
		
		// ().showLookup()
		//
		// Shows the lookup on input fields
		_this.showLookup = function() {
			var i, thisSelector;
			for (i in _this.selectors) {
				if (!Object.prototype.hasOwnProperty.call(_this.selectors, i)) continue;
				thisSelector = _this.selectors[i];
				_this.scope['websysEdit_RestoreLookup'](thisSelector.id);
			}
			return _this;
		};

		// ().extendLookup(listOfParameters)
		// 
		// Set additional parameters to be passed to the lookup component
		// - parameters are only utilised in the ListRowFilter UDFs
		// @param {array} [listOfParameters] - An array of values, may include an optional name
		// 	eg. var extraValues = ['Animal','Gonzo','The Swedish Chef'];
		// 		extraValues.push(websys_getValue('PatientID'));
		// 		extraValues.push({value: websys_getValue('TWKFLNAME')});
		// 		extraValues.push({name: 'EurovisionCode', value: 'nul points'});
		// 		extraValues.push({itemName: 'AnotherItemDesc'});
		// 		extraValues.push({name: 'EnteredSexValue', itemName: '&AnotherTableItemDesc'});
		// 		tkLib('#TTLDesc').extendLookup(extraValues);
		// if listOfParameters is null or undefined or empty array, then clear the additional parameters
		_this.extendLookup = function(listOfParameters) {
			var i, thisSelector;
			for (i in _this.selectors) {
				if (!Object.prototype.hasOwnProperty.call(_this.selectors, i)) continue;
				thisSelector = _this.selectors[i];
				if ((angular.isUndefined(listOfParameters)) || (!angular.isArray(listOfParameters))
				|| (listOfParameters.length === 0)) {
					delete thisSelector.extendedLookupParams;
				} else {
					thisSelector.extendedLookupParams = listOfParameters;
				}
			}
			return _this;
		};

		// ().count()
		//
		// Returns the number of selectors
		_this.count = function() {
			return _this.selectors.length;
		};

		// ().exists()
		//
		// Returns if there is a matched selector
		_this.exists = function() {
			return _this.selectors.length > 0;
		};

		// ().focus()
		//
		// Focus on first selector
		_this.focus = function() {
			if (_this.selectors[0]) _this.scope.focusField(_this.selectors[0].id);
			return _this;
		};

		// ().forEach(fn)
		//
		// Iterates over all selected elements and invokes a passed in function - the document 
		// element can be referenced by this within the function body.
		// If forEachFunction is not supplied then no action is taken
		// If forEachFunction is not a function then no action is taken
		_this.forEach = function(forEachFunction) {  // eslint-disable-line
			if (angular.isUndefined(forEachFunction)) return _this;
			if (!angular.isFunction(forEachFunction)) return _this;
			var i, thisSelector;
			for (i in _this.selectors) {
				if (!Object.prototype.hasOwnProperty.call(_this.selectors, i)) continue;
				thisSelector = _this.selectors[i];
				forEachFunction.call(thisSelector);
			}
			return _this;
		};		

		// ().ready()
		//
		// Stub for $(document).ready(function() {})
		// Called with 'this' being the component scope
		// Note that this similar to an IIFE and will run BEFORE component load handlers
		_this.ready = function(execFunction) {
			if (angular.isFunction(execFunction)) {
				return execFunction.call(_this.scope);
			}
		};
		
		/**
		 * namespace
		 * Creates an Object following the specified namespace identifier
		 * (Function does not use/modify the global scope, as components are correctly scoped in ME UI)
		 * @param {string} identifier - the text name of the object to create in global scope. 
		 * Objects are separated by '.' , e.g. PDS.Object
		 * @param {Object} [definedMembers] - (Optional) An object which properties will be added to the namespace
		 * @returns {Object} The object created in the global scope
		 * @example <caption>Create or return the PDS.Edit object in global scope</caption>
		 * var PDSEditNamespaceObj = tkLib.namespace('PDS.Edit');
		 */
		_this.namespace = function(identifier, definedMembers) {
			$this.namespaceMembers = [];
			if (!angular.isString(identifier) || (identifier === '')) {
				$log.warn('tkLib: Invalid namespace identifier:', identifier);
				return {};
			}
			// Create the namespace within the component scope
			var namespace = _this.scope;
			var parts = identifier.split('.');
			$this.namespaceId = identifier;
			for (var i = 0; i < parts.length; i++) {
				if (!namespace[parts[i]]) {
					namespace[parts[i]] = {};
				}
				namespace = namespace[parts[i]];
			}

			if (definedMembers) {
				for (var member in definedMembers) {
					if (Object.prototype.hasOwnProperty.call(definedMembers, member) && (!namespace[member])) {
						namespace[member] = definedMembers[member];
						$this.namespaceMembers.push(member);
					}
				}
			}

			return namespace;
		};
		
		/****************************************************************************
		* exposeInScope
		* Parameters:
		*  specArray   Array of dependency specification objects - properties:
		*                  name        Name of the item to be surfaced in the scope object
		*                  value       value to set the name property in the scope object to
		*  scope       (Deprecated) Should not be used in ME UI
		*
		* Used to signal which functions should be surfaced in the component scope
		* These functions will be exposed via the component script service by modifying the source
		* (Function does not use/modify the global scope - as components are correctly scoped in ME UI)
		*/
		_this.exposeInScope = function(specArray, scope) {
			if (scope) {
				$log.warn('tkLib: Unsupported call to exposeInScope with specified scope: ', scope);
			}
			angular.forEach(specArray, function(oneSpec) {
				if (scope) {
					scope[oneSpec.name] = oneSpec.value;
				} else {
					// namespace() function is typically called within an IIFE scope
					// Bind these again when called from exposeInScope
					_this.scope[oneSpec.name] = oneSpec.value;
				}
			});
		};

		/****************************************************************************
		* tkMakeServerCallAsync
		* Parameters:
		*	@param {Object} options
		*	- methodName: IRIS method name that is defined in the component Region JS class.
		*				  Method must be white listed in the JS class, and in most cases should be defined there
		* 	- className: [Optional] IRIS class name.
		*							Only used where the method is not defined in the component Region JS class.
		*							Must be a JS class extending websys.AbstractJavaScript
		*	- args: [Optional] Array of arguments to pass to class method. Single non-array value will be wrapped in an array
		*
		* Executes an asynchronous server call to a specified IRIS class method with parameters
		*/
		_this.tkMakeServerCallAsync = function(options) {
			if ((!angular.isFunction($window.fetch)) || (!angular.isFunction($window.Promise))) {
				$log.warn('tkLib.tkMakeServerCallAsync: Not supported in this browser');
				return;
			}
			var errorMessage;
			if (!angular.isObject(options)) {
				errorMessage = ('tkLib.tkMakeServerCallAsync: Options object required');
				$log.error(errorMessage);
				return $window.Promise.reject(Error(errorMessage));
			}
			if ((angular.isUndefined(options.methodName)) || (options.methodName === '')) {
				errorMessage = ('tkLib.tkMakeServerCallAsync: Method name is required');
				$log.error(errorMessage);
				return $window.Promise.reject(Error(errorMessage));
			}
			if ((angular.isUndefined(options.className)) || (options.className === '')) {
				// Default to only allow methods in the Region JS class
				options.className = ('Region.{RegionCode}.JS.' + (_this.scope.componentName));
			}
			var promise = _this.scope['websys_fetch'](options);
			// support jQuery syntax for backwards compatibility
			if (angular.isDefined(promise)) promise.done = promise.then;
			return promise;
		};

		// Injection
		// Apply a code injection/replacement to a currently defined function
		// Spec has the following properties:
		//      fnName              Name of the function to be modified
		//      injectLines         Lines of code to be injected
		//      insertAfter         Source line in the existing function where injectLines will be written to
		//      replaceText         Text to be replaced in the existing function
		//      replaceBy           Text that will be put in where replaceText was previously
		//      showError           Show Error messages (defaults to 'Y')
		//
		// Action performed is ONE of:
		// If injectLines has 1 or more lines present then injectLines will be inserted, or
		// If replaceText has a value then a replacement will be done
		// 
		// The current function is replaced by a function of the same name and parameters with the modfications done.
		//
		// Return values:
		//       1      Success
		//      -1      fnName parameter missing or blank
		//      -2      Passed in fnName is not a function
		//      -3      injectLines is present but no insertAfter has been specified
		//      -4      insertAfter not found within the fnName
		//      -5      replaceText not found within the fnName
		//      -6      Nothing to do - no injectLines parameter or replaceText specified with a value
		//
		// Examples:
		//  tkLib.Injection({
		//              fnName:"SERDesc_changehandlerX",
		//              insertAfter:'{1:"clsInvalid",2:"clsWarning",3:"clsInfo"});}\n',
		//              injectLines: [ 'TRC98060();' ]
		//            });
		//
		//  tkLib.Injection({
		//              fnName:"CTLOCDescLookUpSelect",
		//              replaceText:"alert (objSerDesc.value);\n",
		//              replaceBy  : [ "\n" ]
		//            });
		//
		// Get a list of a functions formal arguments
		// Taken from Angular.js source
		_this.Injection = function(Spec) {
			Spec = (Spec || {});
			var fnName = (angular.isUndefined(Spec.fnName) ? '' : Spec.fnName);
			var showError = (angular.isUndefined(Spec.showError) ? 'Y' : Spec.showError);

			if (fnName === '') {
				if (showError !== '') {
					$window.alert('tkLib.Injection: parameter \'fnName\' expected.');
				}
				return _this.InjectionResult.FunctionNameMissing;
			}

			if (!angular.isFunction(_this.scope[fnName])) { 
				if (showError !== '') {
					$window.alert('tkLib.Injection: Function ' + fnName + ' is not a known function.');
				}
				return _this.InjectionResult.FunctionNameUnknown;
			}
			
			var newFnText = '';
			var fnText = _this.scope[fnName].toString();
			// Allow various types of function definitions (anonymous, with or without whitespace, with or without arguments)
			var fnTextArray = fnText.split(/^\s*function(?:\s+\S*|\s*)\s*\((.*)\)\s*\{/, 3);
			var fnTextArguments = (fnTextArray[1] || '');
			var fnTextContent = fnTextArray[2];
			if (angular.isUndefined(fnTextContent)) {
				$window.alert('tkLib.Injection: Function ' + fnName + ' content could not be parsed.');
				return _this.InjectionResult.FunctionNameUnknown;
			}
			fnText = 'function ' + fnName + '(' + fnTextArguments + ') {' + fnTextContent;
			var injectLineCount = (angular.isObject(Spec.injectLines) ? Spec.injectLines.length : 0);
			var replaceByLineCount = (angular.isObject(Spec.replaceBy) ? Spec.replaceBy.length : 0);
			var replaceTextOriginal = (angular.isUndefined(Spec.replaceText) ? '' : Spec.replaceText);
			var headText;
			var tailText;
			var i;
			//
			// If injectLines are present then do an injection
			if (injectLineCount > 0) {
				var insertAfter = (angular.isUndefined(Spec.insertAfter) ? '' : Spec.insertAfter);
				if (insertAfter === '') {
					if (showError !== '') {
						$window.alert('tkLib.Injection: Function ' + fnName 
								+ ' - injectLines is present but no insertAfter has been specified.');
					}
					return _this.InjectionResult.InsertAfterMissing;
				}
				var insertAfterOffset = fnText.indexOf(insertAfter);
				if (insertAfterOffset === -1) {
					if (showError !== '') {
						$window.alert('tkLib.Injection: Function ' + fnName 
								+ ' - insertAfter (' + insertAfter + ') not found within the function.');
					}
					return _this.InjectionResult.FunctionInsertAfterSourceNotFound;
				}
				var injectLineStartOffset = insertAfterOffset + insertAfter.length;
				headText = fnText.substr(0, insertAfterOffset) + insertAfter;
				tailText = fnText.substr(injectLineStartOffset, fnText.length);
				//
				// Append injected lines now
				for (i = 0; i < injectLineCount; i++) {
					headText = headText + Spec.injectLines[i] + '\n';
				}
				newFnText = headText + tailText;
			} else if (replaceTextOriginal !== '') {
				// OR if replace text is specified then do a replacement
				
				// Convert any single carriage return/new line with carriage return + new line
				// to match the format in function source
				var replaceText = replaceTextOriginal.replace(/(?:\r\n|\r|\n)/g, '\r\n');
				var replaceTextOffset = -1;
				try {
					// Re-generate line in format to match code generator output in componentScriptService
					// Use tolerant parsing to allow replacement of single lines (e.g. return statements)
					var ast = $window.esprima.parseScript(replaceText, {tolerant: true});
					replaceText = $window.astring.generate(ast);
					// Remove any generated line breaks
					replaceText = replaceText.trim();
					replaceTextOffset = fnText.indexOf(replaceText);
				} catch (ex) {
					$log.error('Error parsing source for tkLib.Injection, falling back to string replacement: ', ex);
					$log.error('Source:', replaceTextOriginal);
					// In cases where the parser cannot interpret replaceText due to it being an incomplete line of JS:
					// fallback to a pure string operation (below)
					replaceText = replaceTextOriginal.replace(/(?:\r\n|\r|\n)/g, '\r\n');
					replaceTextOffset = -1;
				}
				try {
					if (replaceTextOffset === -1) {
						// Fallback to using regex to attempt to find the match
						var replaceRegex = '';
						var replaceTextArray = replaceText.split(/(\S)/g);
						replaceTextArray.forEach(function(charValue, charIndex) { // eslint-disable-line
							if (charIndex === 0) return;
							// Build a regex with each character, but allow whitspace between each character
							replaceRegex += ((charValue.trim() === '') ? '\\s*' : ('[' + charValue + ']'));
						});
						if (replaceRegex !== '') {
							// Regex to find any permutation of the replaceText with or without whitespaces between tokens
							replaceRegex = RegExp(replaceRegex, '');
							var regexResult = replaceRegex.exec(fnText);
							if ((regexResult !== null) && (angular.isDefined(regexResult[0]))) {
								replaceText = regexResult[0].trim();
								replaceTextOffset = regexResult.index;
							}
						}
					}
				} catch (ex) {
					replaceTextOffset = -1;
				}
				
				if (replaceTextOffset === -1) {
					if (showError !== '') {
						$window.alert('tkLib.Injection: Function ' + fnName 
								+ ' - replaceText (' + replaceText + ') not found within the function');
					}
					return _this.InjectionResult.FunctionReplaceTextSourceNotFound;
				}
				headText = fnText.substr(0, replaceTextOffset);
				tailText = fnText.substr(replaceTextOffset + replaceText.length, fnText.length);
				//
				// Append injected lines now
				for (i = 0; i < replaceByLineCount; i++) {
					headText = headText + Spec.replaceBy[i] + '\n';
				}
				newFnText = headText + tailText;
			} else {
				if (showError !== '') {
					$window.alert('tkLib.Injection: Function ' + fnName + ' - Nothing to do. Specify injectLines or replaceText ');
				}
				return _this.InjectionResult.NoActionSpecified;
			}

			// Create the new function
			var source = '';
			source += '\tvar $scope = this;';
			// First, declare all scope items as local variables
			angular.forEach(_this.scope, function(item, index) {
				// Don't declare AngularJS internal properties
				if (['$id','$scope','$root','$parent'].indexOf(index) !== -1) return;
				if (index.substr(0, 2) === '$$') return;
				
				source += ('var ' + index + '=this.' + index + ';');
			});
			// The namespace members also need to be declared here
			// because the injection is sometimes done before exposeInScope()
			// (i.e. the injected function closure is called below before the functions are exposed on the scope)						
			angular.forEach($this.namespaceMembers, function(namespaceMember) {
				source += ('var ' + namespaceMember + '=this.' + $this.namespaceId + '.' + namespaceMember + ';');
			});
			
			// then evaluate the function within scope context
			source = source + '\n\treturn ' + newFnText;
			var newFn = new Function(source);
			var parsedFn = newFn.call(_this.scope);
			// Assign it to the passed in variable
			_this.scope[fnName] = parsedFn;
			return parsedFn;
		};
		
		/**
		* tkLib.Injection result codes
		* @type {{Success: number, FunctionNameMissing: number, FunctionNameUnknown: number, InsertAfterMissing: number,
		* FunctionInsertAfterSourceNotFound: number, FunctionReplaceTextSourceNotFound: number, NoActionSpecified: number,
		* IsError: tkLib.InjectionResult.IsError}}
		*/
		_this.InjectionResult = {
			Success: 1,
			FunctionNameMissing: -1,
			FunctionNameUnknown: -2,
			InsertAfterMissing: -3,
			FunctionInsertAfterSourceNotFound: -4,
			FunctionReplaceTextSourceNotFound: -5,
			NoActionSpecified: -6,
			
			/**
			* Query if a tkLib.Injection call result is an error
			* @param resultCode
			* @returns {boolean}
			*/
			IsError: function(resultCode) {
				return ((resultCode === _this.InjectionResult.FunctionNameMissing)
					|| (resultCode === _this.InjectionResult.FunctionNameUnknown)
					|| (resultCode === _this.InjectionResult.InsertAfterMissing)
					|| (resultCode === _this.InjectionResult.FunctionInsertAfterSourceNotFound)
					|| (resultCode === _this.InjectionResult.FunctionReplaceTextSourceNotFound));
			}
		};
		
		/**
		* 
		* checkDependency
		* Validate that items are defined and of the expected type
		* @param {dependency[]} deps
		* 	@typedef {Object} dependency
		* 	@property {string} name - Name of the dependency item
		* 	@property {string} ofType - Expected type of name
		* 	@property {boolean} [raiseError] - (Optional) If true throw an error
		*										if name is not of type ofType (defaults to true)
		* @throws {error}
		* @example <caption>Check that objects and functions are defined</caption>
		*     tkLib.checkDependency([
		*        {name: 'session', ofType: 'object'},
		*        {name: 'SSO', ofType: 'object'},
		*        {name: 't', ofType: 'object'},
		*        {name: 'tkMakeServerCall', ofType: 'function'},
		*        {name: 'websys_cancel', ofType: 'function'},
		*    ]);
		*/
		_this.checkDependency = function(deps) {
			var name,ofType,raiseError,isDefined;
			
			angular.forEach(deps, function(oneDep) {
				// Need at least name and ofType properties (raise error ??)
				if ((angular.isUndefined(oneDep.name))
					|| (angular.isUndefined(oneDep.ofType))) return;
				
				name = oneDep.name;
				ofType = oneDep.ofType;
				
				raiseError = ((angular.isUndefined(oneDep.raiseError)) ? true : oneDep.raiseError);
				// No point in doing anything if we are not raising any errors
				if (!raiseError) return;
				
				try {
					isDefined = (typeof _this.scope[name] === ofType);
				} catch (ex) {
					isDefined = false;
				}
				if (!isDefined) {
					throw new Error('Dependency \'' + name + '\' not declared.');
				}
			});
		};
		
		/**
		* browserSupports
		* [Deprecated] Functionally should be developed with APIs that work across all supported browsers.
		* ActiveX will not be supported in ME UI
		* Determine if a browser supports a requested feature
		* @param featureDesc
		* @returns {boolean}
		* @example <caption>Returns true if the browser supports the FileReader object</caption>
		* var supportsFileReader = tkLib.browserSupports(tkLib.browserSupportsTestFor.FileReader);
		* featureDesc supports the properties in tkLib.browserSupportsTestFor
		*/
		_this.browserSupportsTestFor = {
			FileReader: 'FileReader',
			WebSocket: 'WebSocket',
			ActiveX: 'ActiveX'
		};

		_this.browserSupports = function(featureDesc) {
			$log.warn('tkLib: Call to deprecated function browserSupports');
			if ((angular.isUndefined(featureDesc)) || (featureDesc === '')) {
				return false;
			}
			if (featureDesc === _this.browserSupportsTestFor.ActiveX) {
				return false;
			}
			return true;
		};
		
		/**
		* getErrObjDetails
		* Return a human readable version of a JavaScript error object instance
		* @param {JSErrorObject} errObj - Error object instance
		* @returns {string}
		*
		* Error object definition - browser dependent
		* @typedef {Object} JSErrorObject
		* @property {string} stack
		* @property {string} description
		* @property {string} fileName
		* @property {string} lineNumber
		*/
		_this.getErrObjDetails = function(errObj) {
			if ((angular.isObject(errObj)) && (angular.isDefined(errObj.stack))) {
				return errObj.stack;
			}
			return '';
		};
		
		/**
		* msgFormat
		* Populate a message template with supplied parameter values
		* @param {string} msg - Message template with placeholders for values given by %1, %2...
		* @param {string[]} [params] - (Optional) Template values to replace %1, %2...
		* @returns {string}
		*/
		_this.msgFormat = function(msg, params) {
			if (angular.isUndefined(msg)) return '';
			var outMsg = msg;
			if (angular.isDefined(params)) {
				for (var paramIdx = 0; paramIdx < params.length; paramIdx++) {
					outMsg = outMsg.replace('%' + (paramIdx + 1), params[paramIdx]);
				}
			}
			return outMsg;
		};
		
		/**
		* removeListColumn
		* Hides a list column.
		* Note that the column is only hidden, NOT removed from the DOM.
		* Any editable elements within the column will still be passed to the server on update
		* unless they are explicitly disabled.
		* @param {Object} options
		*	- tag {string|array}: Tag name of the column, defined in MEUI Layout Editor item options.
		*						  May also be an array of tags, to hide multiple columns at once.
		*	- columnIDs {string|array} : [Optional] For backwards compatible call in TCUI
		* 								 May also be an array of column IDs, to hide multiple columns at once.
		* @returns {Object}
		*/
		_this.removeListColumn = function(options) {
			if (!angular.isObject(options)) {
				$log.warn('tkLib.removeListColumn: Options object required');
				return _this;
			}
			options = angular.copy(options);
			options.hidden = true;
			_this.scope['websys_toggleTagged'](options);
			return _this;
		};

		/***** UNSUPPORTED FUNCTIONS ******/
		// Log warning and return empty selector
		_this.closest = _this.filter = _this.forEachCell = _this.parent = function() {
			$log.warn('tkLib: Unsupported call to selector functions');
			_this.selectors = [];
			_this.selectorTags = [];
			return _this;
		};

		_this.removeAttr = function() {
			$log.warn('tkLib: Unsupported call to removeAttr');
			return _this;
		};
		_this.css = function() {
			$log.warn('tkLib: Unsupported call to ().css');
			return _this;
		};
		_this.generateAccordion = function() {
			$log.warn('tkLib: Unsupported call to generateAccordion');
			return '';
		};
		_this.convertTo = function() {
			$log.warn('tkLib: Unsupported call to convertTo');
			return _this;
		};
		_this.intercept = function() {
			$log.warn('tkLib: Unsupported call to intercept');
		};
	}

	$this.getTkLib = function(scope) {
		var tkLib = function(selector) {
			var obj = new _tkLib();
			obj.scope = scope;
			// Fill the selectors array
			if (angular.isDefined(selector)) {
				obj.selectorTags = [];
				// Handle scope element as selector
				if (angular.isDefined(selector.value)) {
					obj.selectors = [selector];
				} else if (angular.isObject(selector) && angular.isDefined(selector.tag)) {
					// Handle tagged layout elements for some operations
					if (angular.isArray(selector.tag)) {
						angular.forEach(selector.tag, function(selectorVal) {
							if (!angular.isString(selectorVal)) return;
							if (!scope.data.tagElements || !scope.data.tagElements[selectorVal]) return;
							obj.selectors.push(scope.data.tagElements[selectorVal]);
							obj.selectorTags.push(selectorVal);
						});
					} else if (angular.isString(selector.tag)
								&& scope.data.tagElements && scope.data.tagElements[selector.tag]) {
						obj.selectors.push(scope.data.tagElements[selector.tag]);
						obj.selectorTags.push(selector.tag);
					} else {
						$log.warn('tkLib(): Invalid selector for tagged layout element: ', selector.tag);
					}
				} else if (angular.isString(selector)) {
					var selectorArray = selector.split(',');
					angular.forEach(selectorArray, function(selectorVal) {
						if (selectorVal[0] !== '#') {
							$log.warn('tkLib(): Invalid selector: ', selectorVal , '. Only #id selectors supported');
						}
						selectorVal = selectorVal.substring(1); // remove first character from selector
						var item = LegacyScopeSearchService.getItemFromDataObject(scope, selectorVal, true);
						if (item) obj.selectors.push(item);
					});
				}
			}
			return obj;
		};
		var selfFunctions = ['namespace', 'exposeInScope', 'Injection', 'tkMakeServerCallAsync'];
		angular.forEach(selfFunctions, function(selfFunction) {
			tkLib[selfFunction] = tkLib()[selfFunction];
		});
		return tkLib;
	};
	
	// Builds and returns a nested object based on the namespace identifier
	// Used when source is parsed in componentScriptService
	$this.getNamespaceObject = function(identifier, namespaceContent) {
		var namespaceObject = {};
		var identifierArray = identifier.split('.');
		// Based on the logic for constructing the namespace in 'namespace' function
		identifierArray.reduce(function(acc, curr, index, arr) {
			if (index === (arr.length - 1)) {
				return (acc[curr] = namespaceContent);
			}
			return (acc[curr] = {});
		}, namespaceObject);
		
		return namespaceObject;
	};
	
});
